
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ekskul",
      function () {
        return require("private-next-pages/ekskul.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ekskul"])
      });
    }
  